<template>
  <span
    v-if="resolvedPercent !== null || resolvedLabel"
    class="inline-flex shrink-0 items-center justify-center rounded-[999px] font-helvetica-700 font-bold leading-none"
    :class="[toneClass, sizeClass]"
  >
    {{ resolvedPercent !== null ? `-${resolvedPercent}%` : resolvedLabel }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    percent?: number | string | null;
    label?: string | null;
    size?: "sm" | "md" | "lg";
    tone?: "solid" | "soft";
  }>(),
  {
    percent: null,
    label: null,
    size: "md",
    tone: "solid",
  },
);

const resolvedLabel = computed(() => props.label?.trim() || "");

const resolvedPercent = computed(() => {
  const parsed =
    typeof props.percent === "string"
      ? Number(props.percent)
      : props.percent ?? null;

  if (!Number.isFinite(parsed) || parsed === null || parsed <= 0) {
    return null;
  }

  return Math.round(parsed);
});

const sizeClass = computed(() => {
  switch (props.size) {
    case "sm":
      return "px-2 py-1 text-[11px]";
    case "lg":
      return "px-3 py-1.5 text-[13px]";
    default:
      return "px-2.5 py-1 text-[12px]";
  }
});

const toneClass = computed(() =>
  props.tone === "soft"
    ? "border border-orange/15 bg-selected-filter text-orange"
    : "bg-orange text-white",
);
</script>
